module.exports = __webpack_public_path__ + "img/7.65889666.jpg";